import React, {FC} from 'react';

import {supportsPopout} from '../../../../libs/shared/core/src/helpers/environment/platformHelpers';
import {CellsPanelId, ViewerPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {InboxesVisualConversationSelection} from '../../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {ViewerPanelPageState} from '../../../store/panels/viewer/viewerPanelState';
import {ConversationHeaderContainer} from './conversation/header/conversationHeaderContainer';
import {ConversationTopbarContainer} from './conversation/topbar/conversationTopbarContainer';
import {ViewerContainer} from './viewerContainer';

/*
 * Props.
 */

interface DockedViewerProps {
  cellsPanelId: CellsPanelId;
  panelId: ViewerPanelId;
  /** Whether this component is visible on screen. Used for Apple Handoff. */
  isActive: boolean;
  topbarPage: ViewerPanelPageState;
  topbarConversationSelection: InboxesVisualConversationSelection;
  contentPage: ViewerPanelPageState;
}

/*
 * Component.
 */

export const DockedViewer: FC<DockedViewerProps> = (props) => (
  <ViewerContainer
    cellsPanelId={props.cellsPanelId}
    panelId={props.panelId}
    isActive={props.isActive}
    renderTopbar={({isOffline}) => (
      <ConversationTopbarContainer
        panelId={props.panelId}
        cellsPanelId={props.cellsPanelId}
        isInPopup={false}
        cellsContext={props.topbarPage.cellsContext}
        inboxesParameters={props.topbarPage.parameters}
        conversationSelection={props.topbarConversationSelection}
        isOffline={isOffline}
      />
    )}
    renderHeader={() => (
      <ConversationHeaderContainer
        panelId={props.panelId}
        cellsPanelId={props.cellsPanelId}
        cellsContext={props.topbarPage.cellsContext}
        inboxesParameters={props.topbarPage.parameters}
        conversationSelection={props.topbarConversationSelection}
      />
    )}
    contentPage={props.contentPage}
    canComposerPopout={supportsPopout()}
  />
);
